export type MonitoringProviderId = 'logrocket' | 'openreplay';

export type MonitoringUserType = 'anonimo' | 'virtual' | 'presencial';

export function resolveMonitoringUserType(
  isAnonymous: boolean,
  userType: string
): MonitoringUserType {
  if (isAnonymous) return 'anonimo';
  return userType === 'Presencial' ? 'presencial' : 'virtual';
}

export interface MonitoringConfig {
  readonly enabled: boolean;
  readonly provider: MonitoringProviderId;
  readonly projectKey: string;
  readonly widgetSupport: boolean;
}

export interface MonitoringUser {
  readonly userId: string;
  readonly metadata: Readonly<Record<string, string>>;
}

export const MONITORING_PROVIDER_IDS: readonly MonitoringProviderId[] = [
  'logrocket',
  'openreplay',
];

export function isMonitoringProviderId(
  value: string
): value is MonitoringProviderId {
  return MONITORING_PROVIDER_IDS.includes(value as MonitoringProviderId);
}

export function parseMonitoringConfig(
  raw: Record<string, unknown> | null | undefined
): MonitoringConfig | null {
  if (!raw?.['projectKey'] || !raw?.['provider']) {
    return null;
  }

  const provider = String(raw['provider']);
  if (!isMonitoringProviderId(provider)) {
    return null;
  }

  const projectKey = String(raw['projectKey']).trim();
  if (!projectKey) {
    return null;
  }

  return {
    enabled: !!raw['enabled'],
    provider,
    projectKey,
    widgetSupport: !!raw['widgetSupport'],
  };
}
